import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { ArrowRight } from 'lucide-react';

export const CTASection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const scrollToBook = () => {
    const element = document.getElementById('book');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      data-testid="cta-section"
      className="relative py-24 md:py-32 bg-[#17798A] overflow-hidden"
    >
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.06]"
        style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '32px 32px' }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 text-center" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-tight text-white mb-6">
            Ready to Create Something
            <br />
            Extraordinary?
          </h2>
          <p className="text-white text-base sm:text-lg max-w-xl mx-auto mb-10">
            Let's connect and bring your next event to life. Every engagement
            starts with a conversation — not a quote.
          </p>
          <button
            onClick={scrollToBook}
            data-testid="cta-button"
            className="btn-primary inline-flex items-center justify-center gap-3 px-10 py-5 text-sm font-bold uppercase tracking-widest text-[#17798A] bg-white hover:bg-[#111111] hover:text-white transition-all duration-300 group rounded-lg"
          >
            Get In Touch
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
